$(document).ready(function() {
	window.all_plant_label = {};
	const search_data = JSON.parse($('.bss-search-product-item')?.text());
  const searchInput = $('#search-plant-input');
	const resultContainer = $('ul#search-result-container');
  const viewAllBtn = $('#view-all-search-result');
  const propertyName = '[name="properties[Plant]"]';
  const formAddToCart = $('#search-plant-input').closest('.product-infomation').find('.bss-custom-buy-button form');

	if (search_data.total_page) {
		window.all_plant_label = search_data.products;
		let index = 1;
		while (index <= search_data.total_page) {
			callDataNextPage(++index);
		}
    displayProducts(window.all_plant_label);
	}

	function callDataNextPage(page) {
		const api_url = window.location.origin + window.location.pathname + `?section_id=bss-search-product-item&page=${page}`;
		fetch(api_url)
		.then(reponse => {
				return reponse.text();
		})
		.then(async (response) => {
			const parser = new DOMParser();
			const responseHtml = parser.parseFromString(response,'text/html');
			const jsonData = JSON.parse(responseHtml.querySelector('.bss-search-product-item').textContent);
			window.all_plant_label = window.all_plant_label.concat(jsonData.products);
		});
	}

  function escapeAttr(text) {
    return String(text).replace(/&/g, '&amp;').replace(/"/g, '&quot;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function filterProducts(showFull = false) {
    const searchText = searchInput.val().toLowerCase();
    const filteredProducts = window.all_plant_label.filter(product =>
      product.name.toLowerCase().includes(searchText)
    );
    displayProducts(filteredProducts, showFull);
  }

  // The label, as it will be engraved: drawn by the labels app from the same
  // file the laser uses. Needs the plant's product id and the chosen tier
  // (variant -> tier map is rendered by bss-search-plant.liquid).
  function currentTier() {
    const sel = formAddToCart.find('[name="id"]');
    const vid = sel.length ? String(sel.val()) : '';
    return (window.bssLabelTiers || {})[vid] || 'plain';
  }
  function updateLabelPreview() {
    const wrap = $('#bss-label-preview-wrap');
    const img = $('#bss-label-preview');
    if (!window.bssSelectedPlantId || !wrap.length) { return; }
    img.attr('src', (window.bssLabelPreviewBase || 'https://labels.herbcottage.com.au/preview.svg')
      + '?product_id=' + encodeURIComponent(window.bssSelectedPlantId)
      + '&plant=' + encodeURIComponent(window.bssSelectedPlantName || '')
      + '&tier=' + encodeURIComponent(currentTier()) + '&w=520'
      + '&v=' + encodeURIComponent(window.bssLabelPreviewVersion || '1'));
    wrap.removeAttr('hidden');
  }
  $(document).on('variant:change', updateLabelPreview);
  if (formAddToCart.length) { formAddToCart.on('change', updateLabelPreview); }

  // Gift message on the back: mirrored into the form as properties[Message]
  // (so it travels with the label line item) and previewed on the real back.
  const msgInput = $('#bss-label-msg');
  let backTimer = null;
  function syncMessage() {
    const m = msgInput.val().replace(/\s+/g, ' ').trim();
    $('#bss-label-count').text(m.length + ' / 96');
    let hidden = formAddToCart.find('[name="properties[Message]"]');
    if (m) {
      if (!hidden.length) {
        hidden = $('<input type="hidden" name="properties[Message]">');
        formAddToCart.append(hidden);
      }
      hidden.val(m);
    } else {
      hidden.remove();
    }
    clearTimeout(backTimer);
    const back = $('#bss-label-back');
    if (!m) { back.attr('hidden', true); return; }
    backTimer = setTimeout(() => {
      back.attr('src', (window.bssLabelPreviewBase || 'https://labels.herbcottage.com.au/preview.svg')
        + '?face=back&layout=lifted&w=520&message=' + encodeURIComponent(m)
        + '&v=' + encodeURIComponent(window.bssLabelPreviewVersion || '1'));
      back.removeAttr('hidden');
    }, 300);
  }
  if (msgInput.length) { msgInput.on('input', syncMessage); }

  function selectPlantLabel(value, productId) {
    window.bssSelectedPlantId = productId || null;
    window.bssSelectedPlantName = value || '';
    updateLabelPreview();
    if (formAddToCart.length) {
      const plantLabelSelector = formAddToCart.find(propertyName);
      if (plantLabelSelector.length) {
        plantLabelSelector.val(value);
      } else {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Plant]';
        input.value = value;
        formAddToCart.append(input);
      }
    }

    $('#plant-selected').html(value);
    searchInput.blur();
  }
  window.selectPlantLabel = selectPlantLabel;

  function displayProducts(products, showFull = false) {
    let productHtml = ``;
    products.forEach((product, index) => {
      if (index > 5 && !showFull) {
        return true;
      }

      productHtml += `
        <li data-tag="${escapeAttr(product.tag_name)}" data-pid="${product.id || ''}" class="snize-product snize-product-out-of-stock snize-product-vendor-herbcottage snize-product-tag-australian-grown-dried-herbs snize-product-tag-decoction snize-product-tag-dried-herbs snize-product-tag-medicinal-dried-herbs snize-product-tag-organic snize-ac-even" style="cursor: pointer;">
          <a href="javascript:void(0)" class="snize-item" draggable="false">
            <div class="snize-thumbnail">
              <img width="70" height="70" src="${product.image}" class="snize-item-image" alt="">
            </div>
            <div class="snize-product-info">
              <span class="snize-title">${product.name}</span>
              <div class="snize-ac-prices-container">
                <div class="snize-price-list">
                  <span class="snize-price money">${product.price}</span>
                </div>
              </div>
              <span class="snize-reviews"></span>
            </div>
          </a>
        </li>
      `;
    });
    resultContainer.html(productHtml);
    resultContainer.find('li').on('click', function () {
      selectPlantLabel($(this).attr('data-tag'), $(this).attr('data-pid'));
    });

    if (products.length > 5 && !showFull) {
      $('#view-all-search-result').show();
    } else {
      $('#view-all-search-result').hide();
    }
  }

	if (searchInput.length) {
		searchInput.focus(function() {
			$('#bss-search-plant-results').fadeIn(300);
		});
	
		searchInput.blur(function() {
      setTimeout(() => {
        $('#bss-search-plant-results').fadeOut(300);
      }, 50)
		});

    $('#bss-search-plant-results').on('mousedown', function (event) {
      event.preventDefault();
    });
	
		searchInput.on('input', function () {
			filterProducts();
		});

    viewAllBtn.click(() => {
			filterProducts(true);
		})
	}

  if (formAddToCart.length && window.bssLabelBaseAvailable === false) {
    formAddToCart.find('[data-add-to-cart]').prop('disabled', true)
      .find('[data-add-to-cart-text]').text('Sold out');
    formAddToCart.closest('.product-infomation').find('.variant-wrapper').hide();
  }

  if (formAddToCart.length) {
    const btnAddtoCart = formAddToCart.find('[type="submit"]');
    btnAddtoCart.on('mousedown', function (event) {
      const plantLabelSelector = formAddToCart.find(propertyName);
      if (!plantLabelSelector?.val()) {
        event.preventDefault();
        searchInput.focus();
      }
    });
  }
})
